"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _backbone = _interopRequireDefault(require("backbone"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCollections = function (data) {
  if (data === void 0) {
    data = {};
  }

  return Object.values(data).filter(function (val) {
    return val instanceof _backbone.default.Collection;
  });
};

var _default = getCollections;
exports.default = _default;